
import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')

// マスタデータ
export const conditionSearch = (page, div) => {
    return http.requestQuickGet(apiUrl.apiurl_masterData + '/' + page + '/' + div)
}

// 検索
export const residentCardGet = (userCd) => {
    return http.requestGet(apiUrl.apiUrl_ResidentCard + '?userId=' + userCd)
}

// 保存
export const residentCardSave = (params) => {
    return http.requestPost(apiUrl.apiUrl_ResidentCard, params)
}

//图片查询
export const i_0007_getImage = (filePath, resizeCd) => {
    return http.requestQuickGetImage('/api/v1/files?filePath=' + encodeURIComponent(filePath) + '&resizeCd=' + resizeCd)
}

//图片更新
export const i_0007_saveImage = (params) => {
    return http.requestPostFormData('/api/v1/files', params)
}


// WEBPACK FOOTER //
// ./src/module/api/i_0007.js